import { c as _c } from "react/compiler-runtime";
import { IconAlertTriangle } from "@tabler/icons-react";
import { ReportSection } from "@/components/domain/report-section";
import { getLookupErrorMessage } from "@/lib/constants/lookup-errors";
import type { SectionDef } from "@/lib/constants/sections";
import type { LookupError } from "@domainstack/core/lookup";
import { Alert, AlertDescription, AlertTitle } from "@domainstack/ui/alert";
function getErrorMessage(error?: LookupError): string {
  if (!error) {
    return "This section couldn't be loaded. Please try refreshing the page.";
  }
  return getLookupErrorMessage(error);
}
interface SectionFailedAlertProps {
  section: SectionDef;
  error?: LookupError;
}

/**
 * Alert shown when a workflow fails to load data for a report section.
 * Wraps the alert in a ReportSection to maintain consistent layout.
 */
export function SectionFailedAlert(t0) {
  const $ = _c(9);
  const {
    section,
    error
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconAlertTriangle className="size-4" />;
    t2 = <AlertTitle>Failed to load data</AlertTitle>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== error) {
    t3 = getErrorMessage(error);
    $[2] = error;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Alert variant="destructive">{t1}{t2}<AlertDescription><p>{t3}</p></AlertDescription></Alert>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== section || $[7] !== t4) {
    t5 = <ReportSection {...section}>{t4}</ReportSection>;
    $[6] = section;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}